import React, { useState, useEffect } from "react";
import { Input } from "design-react-kit";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const DualListbox = (props) => {
  const leftItems = Array.isArray(props.leftItems) ? props.leftItems : [];
  const rightItems = Array.isArray(props.rightItems) ? props.rightItems : [];

  const [leftItemsFiltered, setLeftItemsFiltered] = useState(leftItems);
  const [rightItemsFiltered, setRightItemsFiltered] = useState(rightItems);

  const moveToSelected = (item) => {
    props.setLeftItems(leftItems.filter((x) => x !== item));
    props.setRightItems([...rightItems, item]);
  };

  const moveToAvailable = (item) => {
    props.setRightItems(rightItems.filter((x) => x !== item));
    props.setLeftItems([...leftItems, item]);
  };

  const moveAllToSelected = () => {
    props.setRightItems([...rightItems, ...leftItemsFiltered]);
    props.setLeftItems(
      leftItems.filter((item) => !leftItemsFiltered.includes(item))
    );
  };

  const moveAllToAvailable = () => {
    props.setLeftItems([...leftItems, ...rightItemsFiltered]);
    props.setRightItems(
      rightItems.filter((item) => !rightItemsFiltered.includes(item))
    );
  };

  const [leftFilter, setLeftFilter] = useState("");
  const [rightFilter, setRightFilter] = useState("");

  useEffect(() => {
    const q = leftFilter.trim().toLowerCase();
    setLeftItemsFiltered(
      leftItems.filter((s) => String(s).toLowerCase().includes(q))
    );
  }, [leftFilter, leftItems]);

  useEffect(() => {
    const q = rightFilter.trim().toLowerCase();
    setRightItemsFiltered(
      rightItems.filter((s) => String(s).toLowerCase().includes(q))
    );
  }, [rightFilter, rightItems]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-5">
          <h4>Disponibili</h4>
          <div className="input-group mt-4">
            <Input
              id={`nome_dualListbox_left_${props.id ?? ""}`}
              label="Ricerca elementi disponibili"
              className="flex-grow-1"
              type="text"
              value={leftFilter}
              onChange={(e) => setLeftFilter(e.target.value)}
            />
          </div>

          <ul
            className="list-group"
            style={{ maxHeight: "800px", overflowY: "auto" }}
          >
            {leftItemsFiltered.map((item) => (
              <li key={`${item}-left`} className="list-group-item">
                {item}
                <button
                  type="button"
                  className="btn btn-sm btn-success float-end"
                  onClick={() => moveToSelected(item)}
                >
                  &gt;
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-md-2 mt-5">
          <div className="row justify-content-center mt-5">
            <button
              type="button"
              className="btn btn-primary btn-sm mt-2 w-50"
              onClick={moveAllToSelected}
            >
              &gt;&gt;
            </button>
          </div>
          <div className="row justify-content-center">
            <button
              type="button"
              className="btn btn-primary btn-sm mt-3 w-50"
              onClick={moveAllToAvailable}
            >
              &lt;&lt;
            </button>
          </div>
        </div>

        <div className="col-md-5">
          <h4>Selezionati</h4>
          <div className="input-group mt-4">
            <Input
              id={`nome_dualListbox_right_${props.id ?? ""}`}
              label="Ricerca elementi selezionati"
              className="flex-grow-1"
              type="text"
              value={rightFilter}
              onChange={(e) => setRightFilter(e.target.value)}
            />
          </div>

          <ul
            className="list-group"
            style={{ maxHeight: "800px", overflowY: "auto" }}
          >
            {rightItemsFiltered.map((item) => (
              <li key={`${item}-right`} className="list-group-item">
                {item}
                <button
                  type="button"
                  className="btn btn-sm btn-danger float-end"
                  onClick={() => moveToAvailable(item)}
                >
                  &lt;
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DualListbox;
